import { TFunction } from 'i18next'

import { InvoiceDiscountMode } from '@features/invoices/enums/invoiceDiscountMode'
import { InvoiceDocumentType } from '@features/invoices/enums/invoiceDocumentType'
import { InvoiceForm } from '@features/invoices/types/invoiceForm/invoiceForm'
import { InvoicePayload } from '@features/invoices/types/invoicePayload'
import { calculateRowLineTotals } from '@features/invoices/utils/calculateRowLineTotals'
import { getInvoicePayload } from '@features/invoices/utils/invoicePayload/getInvoicePayload'
import { isInvoiceFormRowLine } from '@features/invoices/utils/isInvoiceFormRowLine'
import { ZervantSettings } from '@features/invoicingSettings/types/zervantSettings'
import { Organization } from '@modules-deprecated/app/organization/types/organization'

import { getDemoInvoiceVisibleColumns } from './getDemoInvoiceVisibleColumns'

interface GetDemoInvoicePayloadOptions {
  discountMode: InvoiceDiscountMode
  invoiceValues: InvoiceForm
  organization?: Organization
  t: TFunction
  zervantSettings?: ZervantSettings
}

export const getDemoInvoicePayload = ({
  discountMode,
  invoiceValues,
  organization,
  t,
  zervantSettings,
}: GetDemoInvoicePayloadOptions): InvoicePayload => {
  const { currency, discountType, invoiceLines } = invoiceValues

  const invoiceLinesWithTotals = invoiceLines.map((line) =>
    isInvoiceFormRowLine(line) ? { ...line, ...calculateRowLineTotals({ currency, discountType, line }) } : line,
  )

  return getInvoicePayload({
    documentType: InvoiceDocumentType.Invoice,
    invoiceValues: { ...invoiceValues, invoiceLines: invoiceLinesWithTotals },
    organization,
    t,
    visibleColumns: getDemoInvoiceVisibleColumns(discountMode),
    zervantSettings,
  })
}
